import { supabase } from '../../lib/supabase';
import type { AppAccessSettingsRow } from '../../utils/appAccessWindow';

export async function getAppAccessSettings(): Promise<AppAccessSettingsRow | null> {
  const { data, error } = await supabase
    .from('app_access_settings')
    .select('id, is_enabled, window_start, window_end, time_zone, updated_at')
    .eq('id', 1)
    .maybeSingle();

  if (error) {
    console.warn('getAppAccessSettings:', error.message);
    return null;
  }
  if (!data) return null;
  return data as unknown as AppAccessSettingsRow;
}

export type UpdateAppAccessSettingsInput = {
  is_enabled: boolean;
  window_start: string;
  window_end: string;
  time_zone: string;
};

export async function updateAppAccessSettings(input: UpdateAppAccessSettingsInput): Promise<void> {
  const { error } = await supabase
    .from('app_access_settings')
    .update({
      is_enabled: input.is_enabled,
      window_start: input.window_start,
      window_end: input.window_end,
      time_zone: input.time_zone,
      updated_at: new Date().toISOString(),
    })
    .eq('id', 1);

  if (error) throw error;
}
